import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { ModalManager, ModalBody, ModalContainer, ModalWrapper, ModalHeader } from './components/Modal'
import { useEffect } from 'react'
import { AdblockDetector } from "react-adblocker-detect";
import "react-adblocker-detect/dist/index.css";

const container = document.getElementById('web-module-root-modal')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
export const AppContext = React.createContext({})

const App = ({ children }) => {
    let modals = [];
    const [currentModal, setCurrentModal] = React.useState(0)

    try {
        const dataString = container.getAttribute('data-modals')
        if (dataString) {
            modals = JSON.parse(dataString)
        }
    } catch (e) {}

    return (
        <>
            {!!modals[currentModal]?.content && (
                <ModalContainer visible={true}>
                    <ModalHeader
                        closeIcon
                        close={() => {
                            setCurrentModal(currentModal + 1)
                        }}
                    />
                    <ModalBody>{modals[currentModal]?.content}</ModalBody>
                </ModalContainer>
            )}
            <AdblockDetector
                config={{
                    persistent: true,
                    pollingTime: 10000,
                    title: "Wykryto AdBlocker!",
                    description: "Zauważyłem, że używasz AdBlockera. Strona może istnieć tylko dzięki reklamom więc jeżeli chcesz zapoznać się ze znajdującą się tutaj treścią proszę wyłącz go.",
                    btn1Title: "Jak wyłączyć AdBlocker?",
                    btn2Title: "Już wyłączyłem AdBlocker."
                }}
            />
            {children}
        </>
    )
}
const renderComponent = (Component) => {
    root.render(
        <AppContext.Provider value={{}}>
            <Component />
        </AppContext.Provider>,
    )
}

renderComponent(App)
